import slide1 from './slide1.md';
import slide2 from './slide2.md';
import slide3 from './slide3.md';
import slide4 from './slide4.md';
import slide5 from './slide5.md';
import slide6 from './slide6.md';
import slide7 from './slide7.md';

export default [ slide1, slide2, slide3, slide4, slide5, slide6, slide7 ];
